import React from 'react';
import PropTypes from 'prop-types';
import Promise from 'bluebird';
import config from '../config';
import { setSection } from '../app/Dictionaries/actions';

export default function connectDataFetchers (Component, actionCreators) {
  const defaultProps = {
    match: {
      params: {},
      path: '',
      url: ''
    }
  };

  class DataFetchersWrapper extends React.Component {
    static fetchData (dispatch, req, match = defaultProps.match) {
      const location = req.server_location
      ? {
        url: req.url || '',
        pathname: req.url || '',
        path: req.path || '',
        params: req.params || {},
        search: req.search || ''
      } : {
        url: req.url || '',
        pathname: req.url || '',
        path: match.path || '',
        params: match.params || {},
        search: req.search || ''
      };

      if (Component.dealType && Component.realtyType) {
        dispatch(setSection(Component.dealType, Component.realtyType));
      }

      return actionCreators.map(actionCreator => dispatch(actionCreator({ location })));
    }

    componentDidMount () {
      if (!config.server_render) {
        Promise.all(DataFetchersWrapper.fetchData(
          this.props.dispatch,
          this.props.location,
          this.props.match
        ));
      }

      config.server_render = false;
    }

    render () {
      return (
        <Component {...this.props} />
      );
    }
  }

  DataFetchersWrapper.is_render = false;

  DataFetchersWrapper.defaultProps = defaultProps;

  DataFetchersWrapper.propTypes = {
    dispatch: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object
  };

  return DataFetchersWrapper;
}



// WEBPACK FOOTER //
// ./src/lib/connectDataFetchers.jsx